import temperature from "./temperature";
import trigger from "./trigger";
import { get } from "@/utils/vuex";

const modules = {
	temperature,
	trigger,
};

const state = () => ({
	sceneWizardType: null,
	sceneNodes: null,
	editMode: false,
});

const getters = {
	availableWizards: () => Object.keys(modules),
	sceneWizardType: state => state.sceneWizardType,
	sceneNodes: state => state.sceneNodes,
	editMode: get("editMode"),
};

const mutations = {
	setSceneType(state, type) {
		state.sceneWizardType = type;
	},

	setSceneNodes(state, nodes) {
		state.sceneNodes = nodes;
	},

	setEditMode(state, mode = true) {
		state.editMode = mode;
	}
};

const actions = {
	addWizard({ dispatch, getters }, { wizard, edit = false, ...args }) {
		const mode = edit ? "update" : "create";
		if (getters.availableWizards.includes(wizard))
			return dispatch(`scenes/${wizard}/${mode}`, args, { root: true });
		return null;
	},

	//
	async checkWizard({ getters, dispatch }, scene) {
		if (!scene) return {};

		const parsedScene = await dispatch("parseScene", scene);
		const matches = await dispatch("matchWizard", parsedScene, { root: true });

		return matches;
	},

	parseScene({ commit }, scene) {
		const {
			triggers,
			children,
		} = scene;

		const commands = children.filter(step => step.targetIsCommand);
		const fireEvents = children.filter(step => step.targetIsEvent);
		const delays = children.filter(step => step.isDelay);

		const {
			dateConditions = [],
			dateTimeOrConditions = [],
			ifConditions = [],
			ifOrConditions = [],
			intervalConditions = [],
			timeConditions = [],
		} = triggers[0] || {};

		const parsedScene = {
			commands,
			fireEvents,
			delays,
			dateConditions,
			dateTimeOrConditions,
			ifConditions,
			ifOrConditions,
			intervalConditions,
			timeConditions,
		};

		commit("setSceneNodes", parsedScene);
		return parsedScene;
	},
};

export default {
	modules,
	state,
	getters,
	mutations,
	actions,
};

